import {
	setCookieOrWebStorage,
	getCookieOrWebStorage
} from './_cookies.js'

export var addPageClass = function() {
    if ($(".mobilePage").length > 0 || $(".desktopPage").length > 0 || $(".tabletPage").length > 0) {
        var classToAdd = "mobilePage";
        if ($(".desktopPage").length > 0) classToAdd = "desktopPage";
        if ($(".tabletPage").length > 0) classToAdd = "tabletPage";
        if (!$("body").hasClass(classToAdd)) $("body").addClass(classToAdd);
        if (!$("html").hasClass(classToAdd)) $("html").addClass(classToAdd);
        var siteFormatCookieValue = classToAdd.split("Page").join("");
        setCookieOrWebStorage("sessionStorage", "siteFormat", siteFormatCookieValue);
    } else if(getCookieOrWebStorage("siteFormat")) {
      var classToAdd = getCookieOrWebStorage("siteFormat") + "Page";
      if (!$("body").hasClass(classToAdd)) $("body").addClass(classToAdd);
      if (!$("html").hasClass(classToAdd)) $("html").addClass(classToAdd);
    } else{
        var thisUserAgent = navigator.userAgent;
        var classToAdd = "mobilePage";
        if (thisUserAgent.indexOf("Mobile") > -1 && thisUserAgent.indexOf("iPad") == -1) {
            classToAdd = "mobilePage";
        } else if (thisUserAgent.indexOf("iPad") > -1 || thisUserAgent.indexOf("Android") > -1) {
            classToAdd = "tabletPage";
        } else {
            classToAdd = "desktopPage";
        }
        $("body").addClass(classToAdd);
        
    }
};
